/* tslint:disable */
/* eslint-disable */
/**
 * Vocalise.API.Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StreaksDto
 */
export interface StreaksDto {
    /**
     * 
     * @type {number}
     * @memberof StreaksDto
     */
    readonly streak?: number;
    /**
     * 
     * @type {number}
     * @memberof StreaksDto
     */
    readonly longestStreak?: number | null;
}

/**
 * Check if a given object implements the StreaksDto interface.
 */
export function instanceOfStreaksDto(value: object): value is StreaksDto {
    return true;
}

export function StreaksDtoFromJSON(json: any): StreaksDto {
    return StreaksDtoFromJSONTyped(json, false);
}

export function StreaksDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): StreaksDto {
    if (json == null) {
        return json;
    }
    return {
        
        'streak': json['streak'] == null ? undefined : json['streak'],
        'longestStreak': json['longestStreak'] == null ? undefined : json['longestStreak'],
    };
}

export function StreaksDtoToJSON(json: any): StreaksDto {
    return StreaksDtoToJSONTyped(json, false);
}

export function StreaksDtoToJSONTyped(value?: Omit<StreaksDto, 'streak'|'longestStreak'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
    };
}

